import { useParams } from 'react-router-dom'
import { Card, CardBody, Row } from 'reactstrap'
import { RouteParams } from '../../api/globalTypes'
import { Tab } from '../../types/global'
import FormMainContainer from '../Common/FormMainContainer'
import FormSideContainer from '../Common/FormSideContainer'
import DocumentForm from './DocumentForm'
import DocumentTable from './DocumentTable'

interface DocumentFormTabProps {
    documentModule?: string
    tabs: Tab[]
    activeTab: string
    contactType?: string
    handleTabChange: (tab: string) => void
}

const DocumentFormTab = (props: DocumentFormTabProps) => {
    const { documentModule, tabs, activeTab, contactType, handleTabChange } = props
    const { id: parentId } = useParams<RouteParams>()

    return (
        <Row>
            <FormSideContainer>
                <Card>
                    <CardBody>
                        <DocumentForm mode="create" documentModule={documentModule} contactType={contactType} parentId={parentId} />
                    </CardBody>
                </Card>
            </FormSideContainer>

            <FormMainContainer tabs={tabs} activeTab={activeTab} handleTabChange={handleTabChange} formik={null}>
                <DocumentTable parentId={parentId} documentModule={documentModule} contactType={contactType} />
            </FormMainContainer>
        </Row>
    )
}

export default DocumentFormTab
